export default __webpack_public_path__ + "static/media/logisticGrayLeft.04bb2045.svg";